import { render, staticRenderFns } from "./InformationReceived.vue?vue&type=template&id=63a4efdd"
import script from "./InformationReceived.vue?vue&type=script&lang=js"
export * from "./InformationReceived.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports